import * as React from "react";

import CostForm from "../../../components/Forms/BrfPremises/CostForm/FlowForm";

export default function BrfPremisesCostsForm() {
  return <CostForm />;
}
